import { useEffect, useState } from "react";
import { useLang } from "../../lib/LangContext";
import { homeCopy } from "../../lib/homeCopy";

// Desktop chapter index. Observes [data-chapter] sections; purely navigational sugar.
export const ChapterRail = () => {
  const { lang } = useLang();
  const labels = homeCopy(lang).chapters;
  const [active, setActive] = useState(1);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const els = [...document.querySelectorAll("[data-chapter]")];
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) setActive(Number(e.target.dataset.chapter)); });
    }, { rootMargin: "-45% 0px -50% 0px" });
    els.forEach((el) => io.observe(el));
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.6);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => { io.disconnect(); window.removeEventListener("scroll", onScroll); };
  }, []);

  const go = (n) => document.querySelector(`[data-chapter="${n}"]`)?.scrollIntoView({ behavior: "smooth", block: "start" });

  return (
    <nav
      aria-label="Chapters"
      data-testid="chapter-rail"
      className={`hidden 2xl:flex fixed right-8 top-1/2 -translate-y-1/2 z-40 flex-col gap-3 transition-opacity duration-500 ${visible ? "opacity-100" : "opacity-0 pointer-events-none"}`}
    >
      {labels.map((label, i) => {
        const n = i + 1;
        const on = n === active;
        return (
          <button
            key={label}
            type="button"
            onClick={() => go(n)}
            data-testid={`chapter-rail-${n}`}
            aria-current={on ? "true" : undefined}
            className="group flex items-center justify-end gap-3 h-5"
          >
            <span className={`text-[10px] tracking-[0.25em] uppercase transition-opacity duration-300 ${on ? "opacity-100 text-white" : "opacity-0 group-hover:opacity-100 text-zinc-400"}`}>{label}</span>
            <span className={`font-mono text-[10px] ${on ? "text-gold" : "text-zinc-600"}`}>{String(n).padStart(2, "0")}</span>
            <span className={`h-px transition-all duration-300 ${on ? "w-8 bg-gold" : "w-4 bg-zinc-700 group-hover:bg-zinc-400"}`} />
          </button>
        );
      })}
    </nav>
  );
};
